import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/** Stripe redirects here when the user cancels checkout. Forward back to the premium page. */
export default function PremiumCancelPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const eventId = sp.get('event_id') || '';

  useEffect(() => {
    navigate(`/host-premium?event_id=${encodeURIComponent(eventId)}`, { replace: true });
  }, [eventId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen" data-testid="premium-cancel-redirect">
      <div className="w-8 h-8 border-2 border-[#146BFF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
